// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2jcCD","share":"styles_share__2TtdH","variant":"styles_variant__280MS","copy":"styles_copy__1cZWA"};